<template>
    <v-container>
    </v-container>
</template>

<script>
export default {
    props: {
    source: String
  },
  data: () => ({
      emailvarifiedcode:'',
      userid:0,
  }),
  created()
  {
    if (this.$route.params.emailvarifiedcode)
    {
        this.emailvarifiedcode = this.$route.params.emailvarifiedcode;
        this.checkemailvarifiedcode();
       // this.fetchTagLocation();

    }
   
    
  },
  methods:
  {
    checkemailvarifiedcode()
    {
        this.$http
        .post(this.$apidomain+"varifiedemail/" + this.emailvarifiedcode)
        .then(res => 
        {
            if (res.data.success == 0)
            {

                



                
            }
            else
            {
                this.userid=res.data.userid;

                localStorage.setItem('userid',this.userid);

                //this.$router.push({name:'frontnew'});

                this.$router.push({name:'varifiedemailconfirm'});

            } 
        })
    }

      
  }
}
</script>